import RegionalCommonUtils from "@/core/utils/regional/RegionalCommonUtils";

class DeUtils {

  /**
   * Валидирует немецкий USt-IdNr (налоговый номер НДС)
   * @param {string} value - USt-IdNr для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateUStIdNr(value) {
    if (typeof value !== 'string') return null;
    if (!/^DE\d{9}$/g.test(value)) return 'Некорректный USt-IdNr.';
    return null;
  }

  static validateLEI = RegionalCommonUtils.validateLEI;
}

export default DeUtils;
